<template>
  <v-card class="pa-8" elevation="1">
    <h2 v-html="$t('page-rules.base-rule.title')" class="font-weight-regular pb-2"></h2>
    <p v-html="$t('page-rules.manage.section-base-rules.underlying')" class="body-2 grey--text text--darken-1"></p>
    <v-data-table
      :headers="headers"
      :items="formatItems"
      disable-pagination
      :hide-default-footer="true"
      :items-per-page="1"
      calculate-widths
    >
      <template v-slot:header.status="{ header }">
        {{ header.text }}
        <primary-tool-tip>
          <span>Status indicates the following states:</span><br>
          <ul>
            <li><strong>Green/Active</strong> - The settings are setup and rule/rate is working correctly</li>
            <li><strong>Orange/Inactive</strong> - You have not completed setup and need to complete the relevant scenarios</li>
          </ul>
        </primary-tool-tip>
      </template>
      <template v-slot:header.checkInDays="{ header }">
        {{ header.text }}
        <primary-tool-tip>
          <span><v-icon color="white" x-small class="mr-2">mdi-account-switch-outline</v-icon><span v-html="$t('global-terms.changeover-days')"></span></span><br>
        </primary-tool-tip>
      </template>
      <template v-slot:item.checkInDays="{ item }">
        <v-chip :title="$t('global-terms.changeover-day')" small class="mr-1 mb-1" v-for="day in item.checkInDays" :key="day.day">{{ day.day }} <v-icon v-if="day.turnaround" class="ml-1" x-small>mdi-account-switch-outline</v-icon></v-chip>
      </template>
      <template v-slot:item.status="{ item }">
        <v-chip
          :color="item.status ? 'green' : 'warning'"
          text-color="white"
          small
        >
          {{ item.status ? $t('global-terms.active') : $t('global-terms.inactive') }}
        </v-chip>
      </template>
      <template v-slot:item.actions="{ item }">
        <v-btn icon :title="$t('global-terms.edit-rule')" :to="{name: 'place-rules-base-edit', params: {ruleId: item.id}}">
          <v-icon small>mdi-pencil</v-icon>
        </v-btn>
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
import { formatCheckInDays } from '@/helpers/bookingRules'
import PrimaryToolTip from '../../../../../components/tooltips/PrimaryToolTip.vue'

export default {
  data () {
    return {
      headers: [
        { text: 'Duration', value: 'duration', sortable: false, width: '20%' },
        { text: 'Check in days', value: 'checkInDays', sortable: false, width: '51%' },
        { text: 'Status', value: 'status', sortable: false, width: '11%' },
        { align: 'end', value: 'actions', sortable: false, width: '4%' },
      ],
    }
  },
  props: {
    rollingBookingRule: {
      type: Object,
      required: true,
    },
  },
  methods: {
    formatCheckInDays,
  },
  computed: {
    formatItems () {
      let rollingBookingRule = {
        id: this.rollingBookingRule.id,
        duration: `${this.rollingBookingRule.duration} months`,
        currency: 'GBP',
        checkInDays: this.formatCheckInDays(this.rollingBookingRule.stayLengths),
        status: this.rollingBookingRule.active,
      }

      return [rollingBookingRule]
    },
  },
  components: {
    PrimaryToolTip,
  },
}
</script>
